import React from "react";
import DMVdeskLogo from "assets/img/DMVdesk.png";

// Define the Manheim component
const DMVdesk = () => {
	// Function to open the OFAC search URL in a new tab securely
	const openInNewTab = () => {
		const newWindow = window.open(
			"https://secure.dmvdesk.com/dmvdesk/",
			"_blank",
			"noopener,noreferrer"
		);
		if (newWindow) newWindow.opener = null;
	};

	return (
		<div
			onClick={openInNewTab}
			style={{ width: "250px", height: "50px", overflow: "hidden" }}
		>
			<img src={DMVdeskLogo} alt="J.D. POWER" style={{ cursor: "pointer" }} />
		</div>
	);
};

export default DMVdesk;
